import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const SelectTestType = () => {

  const navigate = useNavigate()

  const handleGateway = () => {
    navigate('/verify-gateway')
  }

  const handleSite = () => {
    navigate('/test-site')
  }

  return (
    <>
      <Stack
        alignContent={'center'}
        alignItems={'center'}
        spacing={10}
        direction={'column'}
        margin={3}>
        <Typography variant="h1">
          Selezionare tipologia di test
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={handleGateway}
          disabled={false}>
          Verifica gateway
        </Button>

        <Button
          variant="contained"
          fullWidth
          onClick={handleSite}
          disabled={false}>
          Verifica sito
        </Button>
      </Stack>
    </>
  )
}

export default SelectTestType
